export class AuditLogExtendedDataAuth {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "AuditLogAuthStatus",
            "format": ""
        },
        {
            "name": "authMethod",
            "baseName": "authMethod",
            "type": "AuditLogAuthMethod",
            "format": ""
        },
        {
            "name": "mfaRequired",
            "baseName": "mfaRequired",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "mfaMethod",
            "baseName": "mfaMethod",
            "type": "AuditLogMfaMethod",
            "format": ""
        },
        {
            "name": "mfaResult",
            "baseName": "mfaResult",
            "type": "string",
            "format": ""
        },
        {
            "name": "failureReason",
            "baseName": "failureReason",
            "type": "string",
            "format": ""
        },
        {
            "name": "idpName",
            "baseName": "idpName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuditLogExtendedDataAuth.attributeTypeMap;
    }
    constructor() {
    }
}
